<template>
  <nav id="nav" ref="nav">

    <div id="menuIconCont">
      <div class="icon-holder" @click="showMenu()">
        <div class="icon">
          <i class="icofont-navigation-menu" ref="menuIcon"></i>
        </div>
      </div>
    </div>

    <div id="navContainer">

      <div class="navOptions" id="deskMenu" ref="deskMenu">

        <router-link to="/" :style="{color: routeColor, borderColor: routeColor}">
          Résumé
        </router-link>

        <router-link to="/about" :style="{color: routeColor, borderColor: routeColor}">
          + About me
        </router-link>

        <router-link to="/experience" :style="{color: routeColor, borderColor: routeColor}">
          Experience
        </router-link>

        <router-link to="/projects" :style="{color: routeColor, borderColor: routeColor}">
          Projects
        </router-link>

        <router-link to="/contact" :style="{color: routeColor, borderColor: routeColor}">
          Contact
        </router-link>

        <div id="closeMenu" @click="hideMenu">
          <i class="icofont-close"></i>
        </div>
      </div>

      <img src="../assets/logo.svg" alt="logo" id="logo" class="link" @click="goIndex" />
    </div>
  </nav>
</template>

<script>
export default {
  mounted() {
    setTimeout(() => {
      window.addEventListener("scroll", this.onScroll);
      window.addEventListener("resize", this.onResize);
    }, 800);
    this.navVisibility(false);

    window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', () => {
      this.onScroll();;
    })
  },

  data() {
    return {
      routeColor: "#fff",
    }
  },

  methods: {
    hideMenu() {
      let nav = document.getElementById("nav");
      nav.style.width = "0vw";
      document.getElementById("menuIconCont").style.opacity = "0.8";
    },

    showMenu() {
      let nav = document.getElementById("nav");
      nav.style.width = "70vw";
      nav.style.height = "100vh";
      document.getElementById("menuIconCont").style.opacity = "0";
    },

    goIndex() {
      window.location.href = "http://nethanzel.dev";
    },

    onScroll() {
      let page = document.getElementById("page");

      let topPoint = document.getElementById("pTop");
      let upSign = page ? topPoint.getBoundingClientRect().top < 0 : (topPoint.getBoundingClientRect().top + topPoint.offsetHeight) < 0;
      this.upButtom(upSign);

      let color = window.matchMedia('(prefers-color-scheme: dark)').matches;

      if(page && (page.getBoundingClientRect().top < 0)) {
        return this.navVisibility(upSign, color ? "#ffffffb3" : "#000000b3");
      }

      this.navVisibility(upSign);
    },

    onResize() {
      this.onScroll();
    },

    upButtom(show) {
      let upShortcut = document.getElementById("takemeup");
      if (show) {
        upShortcut.style.visibility = "visible";
        upShortcut.style.opacity = "0.8";
        upShortcut.style.top = `${(window.innerHeight * 0.92) - 25}px`;
      } else {
        upShortcut.style.visibility = "hidden";
        upShortcut.style.opacity = "0";
      }
    },

    navVisibility(show, color) {
      let nav = this.$refs.nav;
      let navCnt = document.getElementById("navContainer");

      let icoMenu = this.$refs.menuIcon;

      let mobile = window.matchMedia("(max-width: 1050px)");
      let theme = window.matchMedia('(prefers-color-scheme: dark)').matches;

      nav.style.transition = ".4s";
      navCnt.style.transition = ".4s";

      const showNav = () => {
        mobile.matches ? nav.style.height = "100vh" : nav.style.height = "60px";
        mobile.matches ? nav.style.width = "0vw" : nav.style.width = "100%";
        mobile.matches ? document.getElementById("menuIconCont").style.opacity = "0.8" : document.getElementById("menuIconCont").style.opacity = "0";

        nav.style.opacity = "1";
        icoMenu.style.opacity = "0.8";
      }

      if(show) {
        this.navWhiteOrBlack(color ?? (theme ? "#ffffffb3" : "#000000b3"), theme);
        showNav();
      } else {
        if(this.$route.fullPath != '/') {
          this.navWhiteOrBlack(color ?? (theme ? "#000000b3" : "#ffffffb3"), theme);
          return showNav();
        }
        nav.style.opacity = "0";
        icoMenu.style.opacity = "0";
        mobile.matches ? nav.style.width = "0vw" : nav.style.height = "0px";
      }
    },

    navWhiteOrBlack(color, theme) {
      let navCnt = document.getElementById("navContainer")/* this.$refs.nav */;

      let icoMenu = this.$refs.menuIcon;
      let iconMenuHolder = document.getElementsByClassName("icon-holder")[0];
      let inverseColor = color == "#ffffffb3" ? "#000" : "#fff";

      navCnt.style.background = color;
      this.routeColor = inverseColor;

      if (icoMenu && iconMenuHolder) {
        iconMenuHolder.style.backgroundColor = theme ? "#fff" : "#000";
        icoMenu.style.color = theme ? "#000" : "#fff";
      }

      document.getElementById("closeMenu").style.cssText = `border: 1px solid ${color}; color: ${color}; background: ${inverseColor};`;
    }

  },

  beforeDestroy() {
    window.removeEventListener("scroll", this.onScroll);
    window.removeEventListener("resize", this.onResize);
  },

  watch: {
    $route (to) {
      if(to.name == 'Home') {
        this.navVisibility(false);
      }

      if(window.matchMedia("(max-width: 1050px)").matches) {
        this.hideMenu();
      }
    }
  }
};
</script>

<style scoped lang="scss">

#nav {
  top: -1px;
  left: 0;

  height: 60px;
  width: 100%;
  max-height: 60px;
  position: fixed;
  z-index: 100;
  overflow: hidden;
  background: transparent;
  opacity: 0;
  user-select: none;
}

#navContainer {
  margin: 0 auto;
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
  justify-content: center;
  height: 100%;
  backdrop-filter: blur(6.2px);
  padding-left: 5px;
}

.navOptions {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  max-width: 1250px;
}

#logo {
  height: 30px;
  position: relative;
  cursor: pointer;
}

a {
  text-decoration: none;
  margin-right: 60px;
  padding: 0px 10px 4px 10px;
  min-width: 82px;
  font-size: 14px;
  &:hover {
    filter: invert(.5);
  }
}

.router-link-exact-active {
  padding-top: 2px;
  border-bottom: 3px solid #000;
  font-weight: bold;
  &:hover {
    filter: none;
  }
}

#deskMenu {
  display: flex;
}

.icon {
  font-size: 26px;
  margin: auto;
}

#closeMenu {
  display: none;
  font-size: 23px;
}

#menuIconCont {
  opacity: 0;

  position: fixed;
  z-index: 10;
  top: 0;
  left: 0;

  margin-left: calc(92vw - 25px);
  margin-top: 1em;
  transition: all 0.5s;

}

.icon-holder {
  height: 5.345vh;
  width: 5.345vh;
  min-height: 50px;
  min-width: 50px;
  border-radius: 50%;
  display: flex;
}


@media screen and (max-width: 1050px) {
  #nav {
    top: -1px;
    left: 0;
    height: 0vh;
    width: 0vw;
    max-height: 100vh;
    background: transparent;
    position: fixed;
    z-index: 100;
    overflow: hidden;
    max-width: 70vw;
  }

  #navContainer {
    max-width: 70vw;
    margin: 0 auto;
    display: flex;
    flex-direction: column-reverse;
    padding-left: 0px;
  }

  .navOptions {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    margin: none;
  }

  a {
    text-decoration: none;
    margin-right: 0px;
    margin-bottom: 20px;
    padding: 5px 20px;
    transition: .3s;
    color: #fff;
  }

  #closeMenu {
    display: flex;
    color: #000;
    align-self: center;
    border-radius: 50%;
    background: #fff;
    height: 50px;
    width: 50px;

    display: flex;
    justify-content: center;
    align-items: center;

    margin-top: 50px;
    border: 2px solid #000;
  }

  #logo {
    top: 13px;
    height: 25px;
    cursor: pointer;
  }


  #statusAlert {
    position: absolute;
    width: 100%;
    top: -35px;
    display: none;
  }

  #deskMenu {
    display: flex;
    margin-left: 0px;
    flex-direction: column;
    width: 100%;
  }

  #menuIconCont {
    opacity: .8;
  }

  .icon i {
    color: #fff;
    font-size: 1.2em;
    transition: all 0.6s;
  }
}

@media screen and (max-width: 500px) {
  #menuIconCont {
    margin-left: calc(90vw - 25px);
  }
}

@media screen and (max-width: 375px) {
  #menuIconCont {
    margin-left: calc(88vw - 25px);
  }
}
</style>
